<cc-dashboard-page-container>
  <ng-container title>
    {{ 'sidebar.settings.subitems.NORM_CUBIC_METER' | transloco }}
  </ng-container>

  <cc-table-preview>
    <cc-table-container [isLoading]="isLoading$ | async">
      <div table-buttons class="flex flex-col sm:flex-row">
        <cc-add-action-button
          [routerLink]="[navigateUrl, 'preview', 'new']"
        ></cc-add-action-button>
      </div>

      <bo-mat-table
        matSort
        [data]="paging$ | async"
        (matSortChange)="onSort($event)"
        (pageChange)="setPage($event)"
      >
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'norm-cubic-meter.fields.YEAR' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.year }}
          </td>
        </ng-container>

        <ng-container matColumnDef="factor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'norm-cubic-meter.fields.FACTOR' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.factor }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'norm-cubic-meter.fields.UPDATED_DATE' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedDate | date : 'short' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="updatedByDec">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'norm-cubic-meter.fields.UPDATED_BY' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedByDec.fullName }}
          </td>
        </ng-container>
      </bo-mat-table>
    </cc-table-container>
  </cc-table-preview>
</cc-dashboard-page-container>
